<template>
  <div class="tab-navigation">
    <Tab
      v-for="tab in tabs"
      :key="tab.name"
      :name="tab.name"
      :label="tab.meta.label || $t(`menuItems.${tab.name}`)"
      :active="$route.path === tab.path"
      @change-tab="changeTab(tab.name, tab.routeName, tab.path)"
      @close-tab="closeTab(tab.name, tab.path)"
    />
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';

  import Tab from './Tab.vue';

  export default {
    name: 'TabsNavigation',
    components: {
      Tab,
    },
    computed: {
      ...mapGetters(['tabs', 'tablesStatus']),
    },
    methods: {
      ...mapActions([
        'resetFilters',
        'resetTable',
        'removeTable',
        'resetForm',
        'removeTab',
      ]),
      changeTab(name, routeName, path) {
        const isActive = this.$route.path === path;
        if (!isActive) {
          const tab = this.tabs.find((t) => t.name === name);
          const { query, params } = tab;
          this.$router.push({ name: routeName, query, params });
        }
      },
      closeTab(name, path) {
        const isActive = this.$route.path === path;
        const tabIndex = this.tabs.findIndex((t) => t.name === name);
        const previousIndex = tabIndex - 1;
        const nextIndex = tabIndex + 1;
        const { tableKeys, filterKeys, formKeys, dynamicTableKeysBase } =
          this.tabs[tabIndex].meta;

        // Changes to an active tab (or to the Home page)
        if (isActive) {
          if (this.tabs[previousIndex]) {
            this.changeTab(
              this.tabs[previousIndex].name,
              this.tabs[previousIndex].routeName,
              this.tabs[previousIndex].path
            );
          } else if (this.tabs[nextIndex]) {
            this.changeTab(
              this.tabs[nextIndex].name,
              this.tabs[nextIndex].routeName,
              this.tabs[nextIndex].path
            );
          } else {
            this.$router.push({ name: 'postLogin' });
          }
        }

        // Clears view data
        if (tableKeys) tableKeys.forEach((key) => this.resetTable(key));
        if (filterKeys) filterKeys.forEach((key) => this.resetFilters(key));
        if (formKeys) formKeys.forEach((key) => this.resetForm(key));
        if (dynamicTableKeysBase) {
          const dynamicKeys = Object.keys(this.tablesStatus).filter((key) =>
            key.startsWith(dynamicTableKeysBase)
          );
          dynamicKeys.forEach((key) => {
            this.removeTable({ tableKey: key });
          });
        }

        // Finally removes the tab
        this.removeTab(name);
      },
    },
  };
</script>

<style lang="scss">
  .tab-navigation {
    overflow-x: auto;
    width: 100%;
    white-space: nowrap;
  }
</style>
